export default __webpack_public_path__ + "static/media/image-soccer-team.24ac0872.jpg";